// This file is currently not checked by eslint.
// When you work on this file, please remove its entries from .eslintignore

import breakpoint from './grid/constants';

const isBrowser = () => typeof window !== 'undefined';
const isMmSupported = () => isBrowser() && typeof window.matchMedia === 'function';

const convertToBreakpointObj = (breakpoints = '') =>
  Object.keys(breakpoint).reduce((bpObj, bp) => {
    bpObj[bp] = ` ${breakpoints} `.indexOf(` ${bp} `) > -1;
    return bpObj;
  }, {});

export const createMediaQuery = (breakpoints = {}) => {
  const mq = [];
  if (breakpoints.xs) {
    mq.push(`(max-width: ${breakpoint.sm - 1}px)`);
  }
  if (breakpoints.sm) {
    mq.push(`(min-width: ${breakpoint.sm}px) and (max-width: ${breakpoint.md - 1}px)`);
  }
  if (breakpoints.md) {
    mq.push(`(min-width: ${breakpoint.md}px) and (max-width: ${breakpoint.lg - 1}px)`);
  }
  if (breakpoints.lg) {
    mq.push(`(min-width: ${breakpoint.lg}px) and (max-width: ${breakpoint.xl - 1}px)`);
  }
  if (breakpoints.xl) {
    mq.push(`(min-width: ${breakpoint.xl}px)`);
  }
  return mq.join(', ');
};

export const matchesBp = (breakpoints = '') => {
  if (isMmSupported()) {
    const mq = createMediaQuery(convertToBreakpointObj(breakpoints));
    return window.matchMedia(mq).matches;
  }
  return null;
};

class MQListManager {
  constructor() {
    this.mqListeners = {};
    if (isMmSupported()) {
      window.addEventListener('resize', this.checkAllMediaQueries.bind(this));
    }
  }

  addListener(mq, callback) {
    if (!this.mqListeners[mq]) {
      const mqList = window.matchMedia(mq);
      this.mqListeners[mq] = {
        mqList,
        matches: mqList.matches,
        callbacks: [],
      };
    }
    const mqData = this.mqListeners[mq];
    mqData.callbacks.push(callback);
  }

  removeListener(callback) {
    Object.keys(this.mqListeners).find((mq) => {
      const mqData = this.mqListeners[mq];
      const index = mqData.callbacks.findIndex((cb) => cb === callback);
      if (index > -1) {
        return mqData.callbacks.splice(index, 1);
      }
      return false;
    });
  }

  checkAllMediaQueries() {
    Object.keys(this.mqListeners).forEach((mq) => {
      const mqData = this.mqListeners[mq];
      if (mqData.mqList.matches !== mqData.matches) {
        // We've passed a breakpoint
        mqData.matches = mqData.mqList.matches;
        mqData.callbacks.forEach((cb) => cb(mqData.matches, mqData.mqList));
      }
    });
  }
}

const mqListManager = new MQListManager();

const BreakpointHelper = {
  __mqListManager: mqListManager,
  supported: isMmSupported,
  on: (breakpoints, callback) => {
    if (isMmSupported()) {
      const mq = createMediaQuery(convertToBreakpointObj(breakpoints));
      mqListManager.addListener(mq, callback);
    }
  },
  matches: matchesBp,
  off: mqListManager.removeListener.bind(mqListManager),
};

export default BreakpointHelper;
